export default "__VITE_ASSET__D$K8MQhN__"